import { useMemo } from 'react';
import { FREIGHT_MODE } from '@types';

export const useConvertQueryStringToLane = (queryString: string | null, isLinkedRateCard?: boolean): {
	origin_location: {
        text: string;
        locality_type: 'POSTCODE' | 'REGION'
    };
    destination_location: {
        text: string;
        locality_type: 'POSTCODE' | 'REGION'
    };
    freight_mode: FREIGHT_MODE;
	shipper_tag: string | null
} | null => {
	return useMemo(() => {
		if (!queryString) return null;

		const params = new URLSearchParams(queryString);

		const lane = {
			origin_location: {
				text: params.get('origin_location[text]') || '',
				locality_type: params.get('origin_location[locality_type]') as 'POSTCODE' | 'REGION',
			},
			destination_location: {
				text: params.get('destination_location[text]') || '',
				locality_type: params.get('destination_location[locality_type]') as 'POSTCODE' | 'REGION',
			},
			freight_mode: params.get('freight_mode') as FREIGHT_MODE,
			shipper_tag: params.get('shipper_tag') || null,
			can_exclude_linked_lane: isLinkedRateCard ? isLinkedRateCard : false,
		};

		return lane;
	}, [queryString]);
};
